import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GatewayConfig, SHARED_GATEWAY_CONFIG } from './gateway.config';
import { CdnPrefixPipe } from './environment/cdn-prefix.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [CdnPrefixPipe],
  exports: [CdnPrefixPipe],
})
export class SharedGatewaysModule {
  static withConfig(
    config: GatewayConfig,
  ): ModuleWithProviders<SharedGatewaysModule> {
    return {
      ngModule: SharedGatewaysModule,
      providers: gatewaysProviders(config),
    };
  }
}

export function gatewaysProviders(config: GatewayConfig): Provider[] {
  return [{ provide: SHARED_GATEWAY_CONFIG, useValue: config }];
}
